import { useState } from "react";
import { motion } from "framer-motion";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { toast } from "sonner";
import { adminResetPassword } from "../lib/api";

const inputCls =
  "w-full bg-transparent border border-white/20 px-4 py-3 text-[#E8E2D2] font-mono-accent text-sm focus:border-[#D47738] focus:outline-none transition-colors";

export default function AdminReset() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [pw, setPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 8) {
      toast.error("La password deve avere almeno 8 caratteri");
      return;
    }
    if (pw !== confirm) {
      toast.error("Le password non coincidono");
      return;
    }
    setLoading(true);
    try {
      await adminResetPassword(token, pw);
      setDone(true);
      toast.success("Password reimpostata. Ora puoi accedere.");
      setTimeout(() => navigate("/admin"), 1800);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Link non valido o scaduto");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0D110D] flex items-center justify-center px-6">
      <motion.form
        onSubmit={submit}
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="w-full max-w-sm"
        data-testid="admin-reset-form"
      >
        <Link to="/admin" className="inline-flex items-center gap-2 font-mono-accent text-[10px] uppercase tracking-widest text-[#E8E2D2]/40 hover:text-[#D47738] mb-10">
          <ArrowLeft className="w-3 h-3" /> Torna al login
        </Link>
        <p className="font-mono-accent text-xs uppercase tracking-[0.3em] text-[#D47738] mb-4">
          Recupero Password
        </p>
        <h1 className="font-serif-display text-4xl text-[#E8E2D2] mb-8 leading-none">
          Nuova password
        </h1>
        {!token ? (
          <p className="font-mono-accent text-xs text-[#9E3C3C] uppercase tracking-widest" data-testid="reset-no-token">
            Link non valido: token mancante.
          </p>
        ) : done ? (
          <p className="font-mono-accent text-xs text-[#4A6E4A] uppercase tracking-widest" data-testid="reset-done">
            Password reimpostata. Reindirizzamento al login…
          </p>
        ) : (
          <>
            <input type="password" value={pw} onChange={(e) => setPw(e.target.value)}
              placeholder="Nuova password (min 8)" className={inputCls} data-testid="reset-password-input" />
            <input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)}
              placeholder="Conferma password" className={inputCls + " mt-4"} data-testid="reset-confirm-input" />
            <button type="submit" disabled={loading}
              className="w-full mt-4 bg-[#D47738] text-[#0D110D] py-4 font-mono-accent text-xs uppercase tracking-[0.2em] hover:bg-[#E8E2D2] transition-colors duration-300 disabled:opacity-50"
              data-testid="reset-submit-btn">
              {loading ? "Reimpostazione..." : "Reimposta password"}
            </button>
          </>
        )}
      </motion.form>
    </div>
  );
}
